import { useAppTranslation } from "@/utils";
import { bnplConsumerApis } from "@payping/api";
import type { SDKRequestInit } from "@payping/api";
import { ArrowBlockLeft, DesktopTower, DeviceMobileCamera, PhRCopy } from "@payping/icons";
import { Button, Copy, Flex, Modal, QRCode, Typography, useMessagedAsyncFn } from "@payping/web-components";
import { FC } from "react";

interface Props {
  open?: boolean;
  onClose: () => void;
  trackingCode: string;
}
const GetOrderUploadVideoAndSignaturePageContinueWithMobileModal: FC<Props> = ({ onClose, open, trackingCode }) => {
  const { t } = useAppTranslation();
  const windowUrl = window.location.toString();

  const [sendSmsState, sendSms] = useMessagedAsyncFn(
    async () => {
      try {
        const res = await bnplConsumerApis.sendContinueOnPhoneMessage({ trackingCode }, {
          isRaw: true,
        } as SDKRequestInit);
        return res;
      } catch (e: any) {
        if (e.status === 400) {
          try {
            const parsedError = await e.json();
            throw parsedError;
          } catch (jsonError: any) {
            if (jsonError.status === 400) {
              throw jsonError;
            }
            throw e;
          }
        }
        throw e;
      }
    },
    [trackingCode],
    { loading: false },
    { error: true },
  );

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={t("pay.getOrder.steps.uploadVideoAndSignature.openInMobileModal.title")}
      footer={null}
    >
      <Flex vertical className="tw:w-full" gap={"small"}>
        <Flex className="tw:w-full tw:bg-color-bg-layout tw:p-4!" vertical align="center" gap={"middle"}>
          <QRCode value={windowUrl} />
          <Flex align="center" gap={"middle"} className="tw:text-color-primary">
            <DesktopTower width={24} height={24} />
            <ArrowBlockLeft width={24} height={24} />
            <DeviceMobileCamera width={24} height={24} />
          </Flex>
        </Flex>
        <Typography.Title level={5} className="tw:m-0!">
          {t("pay.getOrder.steps.uploadVideoAndSignature.openInMobileModal.title2")}
        </Typography.Title>
        <Typography.Text type="secondary">
          {t("pay.getOrder.steps.uploadVideoAndSignature.openInMobileModal.content")}
        </Typography.Text>
        <Flex className="tw:py-5!" justify="space-between" align="center">
          <Button type="link" icon={<PhRCopy width={14} height={14} />}>
            <Copy text={windowUrl}>
              <Flex gap={"small"} className="tw:dir-ltr!">
                {t("common.copyLink")}
              </Flex>
            </Copy>
          </Button>
          <Button loading={sendSmsState.loading} onClick={sendSms}>
            {t("pay.getOrder.steps.uploadVideoAndSignature.openInMobileModal.sendLinkBySMS")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default GetOrderUploadVideoAndSignaturePageContinueWithMobileModal;
